import React, { useEffect, useRef, useState } from 'react';
import { useEditWardMutation } from './wardSlice';

function WardEdit({ refOpen, editData, setEditData }) {
    // const [survey, setsurvey] = useState('')


    // useEffect(() => {
    //     setsurvey(editData?.is_survey)
    // }, [editData])

    const refCloseDriver = useRef(null);
    const [editWard, { isLoading }] = useEditWardMutation()

    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const response = await editWard({
                ward_id: editData?.ward_id,
                body: { ward_number: editData?.ward_number }
            });
            refCloseDriver.current.click();
            setEditData({ ward_number: "", is_survey: "", });
            console.log("response", response);
        } catch (e) {
            console.error("Error in cleaner edit", e);
        }
    };

    // const handle = async (e) => {
    //     e.preventDefault()

    //     try {
    //         await editWard({ 'ward_id': editData?.ward_id, body: { is_survey: editData?.is_survey === 1 ? '0' : '1' } })
    //     } catch (e) {
    //         console.error(e)
    //     }
    // }
    return (
        <>

            <button
                ref={refOpen}
                type="button"
                className="btn d-none"
                data-bs-toggle="offcanvas"
                data-bs-target="#depOffCanvas1"
                aria-controls="depOffCanvas1"
            ></button>

            <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="true"
                data-bs-backdrop="false"
                tabIndex="-1"
                id="depOffCanvas1"
                aria-labelledby="depOffCanvas1"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit Ward</h5>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        ref={refCloseDriver}
                    ></button>
                </div>
                <div className="offcanvas-body">
                    <form className="row g-3">
                        <div className="col-md-12 text-left">
                            <label htmlFor="name" className="form-label font-weight-bold">ward</label>
                            <input
                                type="text"
                                className="form-control"
                                id="ward_number"
                                name="ward_number"
                                value={editData?.ward_number}
                                onChange={handleChange}
                                placeholder="Ward"
                                autoComplete="off"
                                required
                            />
                        </div>
                        {/* <div className="form-check form-switch">
                            <input className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                checked={setsurvey}
                                onClick={handle}
                            />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div> */}
                        <div className="col-md-12">
                            <button
                                type="submit"
                                className="btn btn-ff9b44 btn-block btn-round"
                                onClick={handleClick}
                            >
                                {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default WardEdit;
